import { ConnectedRouter } from 'connected-react-router/immutable';
import FastClick from 'fastclick';
import { createBrowserHistory } from 'history';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import DrawerProvider from './components/layout/drawer/DrawerProvider';
import App from './containers/layout/App';
import ModalDialog from './containers/layout/ModalDialog';
import Notifications from './containers/layout/Notifications';
import { init } from './modules/app/actions';
import routes from './routes/routes';
import configureStore from './store/configureStore';

const history = createBrowserHistory();
const store = configureStore(history);
store.dispatch(init());

FastClick.attach(document.body);

render(
  <Provider store={store}>
    <App>
      <DrawerProvider>
        <ConnectedRouter history={history}>
          <React.Fragment>
            {routes}
            <ModalDialog />
          </React.Fragment>
        </ConnectedRouter>
        <Notifications />
      </DrawerProvider>
    </App>
  </Provider>,
  document.querySelector('.js-main')
);

window.store = store;
